import StepsImage1 from "./steps-images-1.webp";
import StepsImage2 from "./steps-images-2.webp";
import StepsImage3 from "./steps-images-3.webp";
import StepsImage4 from "./steps-images-4.webp";
import StepsImage5 from "./steps-images-5.webp";
import StepsImage6 from "./steps-images-6.webp";

export { StepsImage1, StepsImage2, StepsImage3, StepsImage4 , StepsImage5, StepsImage6 };
